<flatpickr>
  <input { ...props.input } type="text" data-input data-flatpickr disabled="{ props.disabled }" onchange="{ onChange }"
    value="{ getValue() }" class="form-control-just" placeholder="{ props.placeholder }"
    required="{ props.required }" />
  <script>
    import flatpickr from 'flatpickr';
    import dayjs from 'dayjs';
    export default {
      pickr: null,
      onChange(e) {
        const value = e.target.value ? dayjs(e.target.value.replace(/\(.*\)/, '')).format(this.props.format || 'YYYY-MM-DD') : '';
        if (value === '') {
          this.pickr?.setDate(this.getValue(), false);
          return;
        }
        if (this.props.onChange) {
          this.props.onChange(value);
        }
      },

      getValue() {
        const date = dayjs(this.props.value);
        if (date.isValid()) {
          return date.format(this.props.format || 'YYYY-MM-DD(dd)');
        } else {
          return '';
        }
      },

      onClose(selectedDates, dateStr, instance) {
        const selectedDate = dayjs(dateStr);
        if (this.props.isResv && selectedDate.month() !== instance.currentMonth) {
          window.openAlert('表示中の月と予約日時の月が異なります');
        }
        if (this.props.isAdmin && (selectedDate.month() !== instance.currentMonth || selectedDate.year() !== instance.currentYear)) {
          window.openAlert('表示中の月と選択日時の月が異なります');
        }
        const date = dayjs(this.props.value);
        if (this.props.value && date.isValid()) {
          this.pickr?.changeMonth(date.month(), false);
        }
      },

      onMounted() {
        this.pickr = flatpickr(this.$('[data-flatpickr]'), { ...this.props.options, disableMobile: true, dateFormat: 'Y-m-d(D)', onClose: this.onClose });
      },

      onBeforeUpdate() {
        const value = this.getValue();
        if (this.props.hasOwnProperty('value') && value != this.pickr?.element?.value && typeof this.pickr?.setDate === 'function') {
          this.pickr?.setDate(value, false);
        }
        if (this.pickr && this.props.options) {
          if (dayjs(this.pickr.now).format('YYYYMMDD') != dayjs(this.props.options?.now).format('YYYYMMDD')) {
            if (typeof this.pickr?.destroy === 'function') {
              this.pickr.destroy();
            }
            this.pickr = flatpickr(this.$('[data-flatpickr]'), { ...this.props.options, disableMobile: true, dateFormat: 'Y-m-d(D)', onClose: this.onClose });
          }
        }
      },

      onBeforeUnmount() {
        if (this.pickr && typeof this.pickr?.destroy === 'function') {
          this.pickr.destroy();
          this.pickr = null;
        }
      }
    };
  </script>
  <style>
    .form-control-just {
      width: 150px;
    }

    .form-control-just[readonly] {
      background-color: white;
    }
  </style>
</flatpickr>